.trigger {
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  border: 1px solid rgb(0 0 0 / 20%);

  &:hover {
    background-color: rgb(0 0 0 / 5%);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 2px white,
      0 0 0 4px rgb(0 0 0 / 50%);
  }
}

.dialogMain {
  display: grid;
  gap: 40px;
  width: 934px;
  max-height: 80vh;
  padding: 40px 96px;
  overflow-y: auto;
}

.form {
  display: grid;
  gap: 40px;
}

.formSection {
  display: grid;
  gap: 12px;
}

.mailTitleSection {
  gap: 18px;
}

.formSectionLabel {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.26px;
}

.formFields {
  display: grid;
  gap: 32px;
}

.radioLabel {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  align-items: end;
  font-size: 15px;
  line-height: 1.5;
}

.titlePostFix {
  width: 97px;
  font-size: 15px;
}

.description {
  font-size: 13px;
  font-weight: 300;
  line-height: 1.55;
  color: rgb(0 0 0 / 60%);
}

.textarea {
  padding: 16px;
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
  resize: vertical;
  border: 1px solid rgb(0 0 0 / 20%);
  border-radius: 8px;

  &:focus {
    outline: none;

    &:not([aria-invalid='true']) {
      border-color: #000;
    }
  }

  &[aria-invalid='true'] {
    color: #e6160f;
    border-color: #e6160f;
  }
}

.checkboxIndicator {
  position: absolute;
}

.mailHeaderLabel {
  display: grid;
  grid-template-columns: 1fr 223px;
  gap: 16px;
  align-items: center;
  width: 100%;
  font-size: 15px;
}

.input {
  width: 100%;
  padding-block: 11px;
  padding-inline: 16px;
  border: 1px solid rgb(0 0 0 / 20%);
  border-radius: 8px;

  &:disabled {
    color: rgb(0 0 0 / 30%);
    cursor: not-allowed;
    background-color: unset;
  }

  &:focus {
    outline: none;

    &:not([aria-invalid='true']) {
      border-color: #000;
    }
  }

  &[aria-invalid='true'] {
    color: #e6160f;
    border-color: #e6160f;
  }
}

.mailHeaderPostfix {
  white-space: nowrap;
}

.emailField {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
}

.buttons {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  justify-content: center;
}

.button {
  width: 175px;
  padding-block: 11.5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.8;
  letter-spacing: -0.52px;
  border-radius: 8px;
}

.buttonFlat {
  color: var(--color-white);
  background-color: #000;

  &:hover {
    background-color: rgb(77 77 77);
  }

  &:disabled {
    background-color: rgb(0 0 0 / 30%);
  }

  &:hover:not(:disabled) {
    background-color: #333;
  }
}

.buttonOutline {
  border: 1px solid rgb(0 0 0 / 20%);

  &:hover {
    background-color: rgb(0 0 0 / 5%);
  }
}

.gap8 {
  display: grid;
  gap: 8px;
}

.error {
  font-size: 15px;
  color: #e6160f;
}

.mailTitleFieldset {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  & > label {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    min-height: 24px;
    margin-left: -40px;
    word-break: break-all;
  }
}

.mailTitleTextarea {
  overflow: hidden;
  resize: none; /* stylelint-disable-line plugin/no-unsupported-browser-features */
}
